<template>
  <iframe 
    src="https://docs.google.com/forms/d/e/1FAIpQLSfT69qLK9cfHbIp_DrwW5Ng1IqBskvagye6zDL0rRV0v3ZqCA/viewform?embedded=true" 
    width="100%"
    height="1000"
    frameborder="0" 
    marginheight="0" 
    marginwidth="0"
  >
    読み込んでいます…
  </iframe>
</template>

<script>
export default {
  mounted () {
    document.title = 'Contact | 株式会社ブイワン';
  }
};
</script>
